import { FormBase } from 'core/components';

export default class FacilityOrderNewFlowUSIntakeFindAndReplaceModalForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "currentProductId",
                    label: "FACILITY_ORDER_NEW_FLOW_FIND_AND_REPLACE.EDIT.CURRENT_PRODUCT_LABEL",
                    placeholder: "FACILITY_ORDER_NEW_FLOW_FIND_AND_REPLACE.EDIT.CURRENT_PRODUCT_PLACEHOLDER",
                    rules: "string|required",
                },
                {
                    name: "newProductId",
                    label: "FACILITY_ORDER_NEW_FLOW_FIND_AND_REPLACE.EDIT.NEW_PRODUCT_LABEL",
                    placeholder: "FACILITY_ORDER_NEW_FLOW_FIND_AND_REPLACE.EDIT.NEW_PRODUCT_PLACEHOLDER",
                    rules: "string",
                },
            ],
        };
    }
}
